import { ref, onMounted, watch } from 'vue'
import Google from '@/constants/google'

const URLS = {
    icons: {
        marker: '/images/icons/marker-yellow.png'
    }
}

const placesTriggered = ref(false)

export const useGoogleAPI = () => {
    const lat = ref(0)
    const lng = ref(0)
    const fullAddress = ref('')
    const business = ref('')
    const website = ref('')
    const apiLoaded = ref(false)

    const _map = ref(null)
    const _autocomplete = ref(null)
    const _geocoder = ref(null)
    const _marker = ref(null)
    const _circle = ref(null)
    const _checkInterval = ref(null)

    watch(apiLoaded, function (loaded) {
        if (loaded) {
            _checkInterval.value = null
        }
    })

    onMounted(() => {
        _checkInterval.value = setInterval(() => {
            if (window.google) apiLoaded.value = true
        })
    })

    function initialize({ mode, templateRef, location, types }) {
        switch (mode) {
            case 'map':
                return _initMapData(templateRef)
            case 'autocomplete':
                return _initAutocompleteData(templateRef, types)
            case 'circle':
                return _initCircleData(templateRef)
            case 'geocoder':
                return _initGeocoderData(location)
            default:
                return
        }
    }
    function _initMapData(templateRef) {
        _map.value = new google.maps.Map(templateRef, Google.DEFAULT_MAP_OPT)
    }
    function _initAutocompleteData(templateRef, types) {
        _autocomplete.value = new google.maps.places.Autocomplete(templateRef, {
            fields: ['geometry', 'formatted_address', 'name', 'website'],
            types: types ? types : ['geocode', 'establishment'],
            componentRestrictions: { country: 'us' }
        })

        _autocomplete.value.addListener('place_changed', _handlePlaceChanged)
    }
    function _initCircleData() {
        const radius = _convertToMeters(Google.DEFAULT_MAP_RADIUS)

        _marker.value = new google.maps.Marker({
            map: _map.value,
            position: _map.value.getCenter(),
            title: 'some location',
            icon: URLS.icons.marker
        })

        _marker.value = new google.maps.Circle({
            map: _map.value,
            radius: radius,
            strokeColor: '#cdeb09',
            fillColor: '#cdeb09',
            fillOpacity: 0.15
        })

        _circle.value.bindTo('center', _marker.value, 'position')
    }
    function _initGeocoderData(location) {
        const { city, state, zip } = location
        const address = `${city}, ${state}, ${zip}`
        _geocoder.value = new google.maps.Geocoder()

        _geocoder.value.geocode({ address }, (results, status) => {
            if (status === window.google.maps.GeocoderStatus.OK) {
                lat.value = results[0].geometry.location.lat()
                lng.value = results[0].geometry.location.lng()

                fullAddress.value = results[0].formatted_address
            }
        })
    }
    function _handlePlaceChanged() {
        placesTriggered.value = false

        const place = _autocomplete.value.getPlace()

        if (place.geometry && place.formatted_address) {
            lat.value = place.geometry.location.lat()
            lng.value = place.geometry.location.lng()
            business.value = place.name
            website.value = place.website
            fullAddress.value = place.formatted_address

            if (_map.value) {
                _map.panTo({ lat, lng })
            }

            if (_circle.value) {
                this.mapData.circle.setCenter(new google.maps.LatLng(lat, lng))
            }
        }

        placesTriggered.value = true
    }
    function _convertToMeters(miles) {
        miles = parseFloat(miles)

        return Math.floor(miles * 1609.34)
    }
    return {
        apiLoaded,
        website,
        lat,
        lng,
        fullAddress,
        business,
        placesTriggered,

        initialize
    }
}
